import { MoveableObject } from 'foundations-components/transitional/components/MoveableObject';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
//@ts-expect-error Untyped import
import UIDragListItem from 'ui-addon-draggable/list/UIDragListItem';
//@ts-expect-error Untyped import
import UISortableList from 'ui-addon-draggable/list/UISortableList';
import { DragListHandle } from './OptionOrderInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OptionOrderInput = ({
  getSelectedOptionLabel,
  OptionOrderToolbar,
  onSelectionChange,
  selectedOptions
}) => {
  const selectedValues = selectedOptions.map(option => option.value);
  return /*#__PURE__*/_jsx(UISortableList, {
    dragGroup: "selected-items",
    onOrderChange: newOrder => {
      const updatedSelections = newOrder.reduce((memo, value) => {
        const match = selectedOptions.find(option => value === option.value);
        return match /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */ ? memo.concat(match) : memo;
      }, []);
      onSelectionChange(updatedSelections);
    },
    order: selectedValues,
    children: selectedOptions.map(option => {
      const {
        value
      } = option;
      return /*#__PURE__*/_jsx(UIDragListItem, {
        dragId: value,
        children: /*#__PURE__*/_jsx(MoveableObject, {
          marginBlockStart: "300",
          DragHandle: DragListHandle,
          onClose: () => {
            const updatedSelections = selectedOptions.filter(selection => selection.value !== option.value);
            onSelectionChange(updatedSelections);
          },
          children: /*#__PURE__*/_jsxs(TFlex, {
            justify: "between",
            children: [/*#__PURE__*/_jsx(TruncateString, {
              children: getSelectedOptionLabel ? getSelectedOptionLabel(option) : option.text
            }), OptionOrderToolbar && /*#__PURE__*/_jsx(OptionOrderToolbar, {
              optionValue: value,
              selectedValues: selectedValues
            })]
          })
        }, `item-${value}`)
      }, value);
    })
  }, "selected-list");
};
export default OptionOrderInput;